/**
 * The order of values here will also be the order of options when used in <EnumSelector>
 */
export enum BusinessImpactEnum {
    NEW_SALES = 1,
    NEW_LEADS = 2,
    CUSTOMER_SATISFACTION = 3,
    COMPLIANCE = 4,
    INTERNAL_PRIORITY = 5,
    OTHER = 1000,
}

export const BusinessImpactEnumDict = {
    [BusinessImpactEnum.NEW_SALES]: 'New Sales',
    [BusinessImpactEnum.NEW_LEADS]: 'New Leads',
    [BusinessImpactEnum.CUSTOMER_SATISFACTION]: 'Customer Satisfaction',
    [BusinessImpactEnum.COMPLIANCE]: 'Compliance',
    [BusinessImpactEnum.INTERNAL_PRIORITY]: 'Internal Prioritization',
    [BusinessImpactEnum.OTHER]: 'Other',
};
